import BrandMark from './BrandMark';
const TAGLINE = 'A quant neolab focused on research and trading operations.';

const LINKS = [
  ['What we do', '/#what-we-do'],
  ['The process', '/#process'],
  ['White paper', '/whitepaper/'],
  ['Research', '/research/'],
  ['Prometheus', '/prometheus/'],
  ['Brand', '/brand/'],
];

export default function Footer() {
  return (
    <footer className="footer theme-dark" data-nav-tone="dark">
      <div className="container footer__inner">
        <div className="footer__top">
          <div className="footer__id">
            <a className="footer__brand" href="/">
              <BrandMark />
              <span>QSI Labs</span>
            </a>
            <p className="footer__tagline">{TAGLINE}</p>
          </div>
          <nav className="footer__nav" aria-label="Footer">
            <ul>
              {LINKS.map(([label, href]) => (
                <li key={href}>
                  <a href={href}>{label}</a>
                </li>
              ))}
            </ul>
          </nav>
        </div>
        <div className="footer__base">
          <p className="footer__copy">© {new Date().getFullYear()} QSI Labs</p>
          <p className="footer__legal">
            Nothing on this site is an offer to sell, or a solicitation of an offer to buy, any security or investment product,
            and nothing on it is investment, legal or tax advice. All performance figures are internal and unaudited.
            Material linked from this site may include hypothetical or backtested results, which do not reflect actual trading.
            Past performance is not indicative of future results. Targets and hypotheses are labelled as such and are not
            forecasts.
          </p>
        </div>
      </div>
    </footer>
  );
}
